/** Public build-time identifiers only (no secrets). */
export const ENV = {
  /** `1` serves every API call from MSW fixtures (local design and test) */
  mock: import.meta.env.VITE_MOCK === "1" || import.meta.env.MODE === "test",
  environment: ((import.meta.env.VITE_ENV as string | undefined) ?? "dev") as
    "production" | "staging" | "dev",
  /** Entra app registration B (single tenant, GuestPilot's own tenant, BR-241) */
  clientId: (import.meta.env.VITE_AAD_CLIENT_ID as string | undefined) ?? "",
  tenantId: (import.meta.env.VITE_AAD_TENANT_ID as string | undefined) ?? "",
  apiScope: (import.meta.env.VITE_API_SCOPE as string | undefined) ?? "",
};
